var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_359",
    "data-name": "Groupe 359",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.466,
    height: 21.965,
    viewBox: "0 0 25.466 21.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 25.466,
    height: 21.965,
    transform: "translate(0 0)",
    fill: "#015c7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_358",
    "data-name": "Groupe 358",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2847",
    "data-name": "Trac\\xE9 2847",
    d: "M0,12.572a3.509,3.509,0,0,1,.353-.5Q6.2,6.209,12.062.356a2.03,2.03,0,0,1,.22-.2.732.732,0,0,1,.9,0,2.058,2.058,0,0,1,.22.2Q19.26,6.21,25.117,12.064a.835.835,0,0,1,.307.9.75.75,0,0,1-1.154.378A2.375,2.375,0,0,1,24,13.095q-5.505-5.5-11.008-11.008a3.011,3.011,0,0,1-.2-.251l-.125-.057a1.2,1.2,0,0,1-.158.284Q6.975,7.6,1.438,13.121a1.3,1.3,0,0,1-.529.34c-.387.107-.652-.074-.909-.541Z",
    transform: "translate(0 0)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2848",
    "data-name": "Trac\\xE9 2848",
    d: "M13.282,48.627H28.7v-.3q0-3.618,0-7.235a1.408,1.408,0,0,1,.044-.391.748.748,0,0,1,1.456.131,2.53,2.53,0,0,1,.015.323q0,4,0,8.006c0,.746-.256,1-1,1H12.662a.793.793,0,0,1-.9-.9c0-1.127,0-2.254,0-3.382q0-2.375,0-4.749a1.588,1.588,0,0,1,.047-.442.747.747,0,0,1,.793-.509.764.764,0,0,1,.671.665,2.607,2.607,0,0,1,.007.3q0,3.58,0,7.161v.324",
    transform: "translate(-8.257 -28.2)",
    fill: "#015c7e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.e5151231fc670c1784ad741b6b1175c7.svg";
export { ForwardRef as ReactComponent };